
define("rv!templates/invoicecorrections",[],function(){return { v:3,
  t:[ { t:7,
      e:"div",
      a:{ "class":"span4" },
      f:[ { t:7,
          e:"input",
          a:{ type:"hidden",
            name:"DestinationID",
            value:[ { t:2,
                r:"DestinationID" } ] } },
        " ",
        { t:3,
          r:"ISPRID" },
        " ",
        { t:7,
          e:"div",
          f:[ { t:3,
              r:"ReadOnlyData" } ] },
        " ",
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"strong",
          f:[ "Folio Number" ] },
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"input",
          a:{ type:"text",
            name:"FolioNumber",
            value:[ { t:2,
                r:"FolioNumber" } ] } },
        " ",
        { t:7,
          e:"br" },
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"strong",
          f:[ "Invoice Number" ] },
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"input",
          a:{ type:"text",
            name:"InvoiceNumber",
            value:[ { t:2,
                r:"InvoiceNumber" } ] } },
        " ",
        { t:7,
          e:"br" },
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"strong",
          f:[ "Invoice Date" ] },
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"input",
          a:{ type:"text",
            name:"InvoiceDate",
            value:[ { t:2,
                r:"InvoiceDate" } ],
            id:"txtInvoiceDate" } },
        " ",
        { t:7,
          e:"br" },
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"strong",
          f:[ "Our Total: ",
            { t:2,
              x:{ r:[ "formatMoney",
                  "RoomRateTotal",
                  "HotelFeesTotal",
                  "HotelTaxFeesTotal" ],
                s:"_0(parseFloat(_1)+parseFloat(_2)+parseFloat(_3))" } } ] },
        " ",
        { t:7,
          e:"button",
          a:{ type:"button",
            "class":"btn btn-small" },
          v:{ click:"onOursEqualsTheirs" },
          f:[ "Ours Equals Theirs" ] },
        " ",
        { t:7,
          e:"br" },
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"strong",
          f:[ "Invoice Room Rate Total" ] },
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"input",
          a:{ type:"text",
            name:"InvoiceRoomRateTotal",
            value:[ { t:2,
                r:"InvoiceRoomRateTotal" } ],
            "class":[ "NumberBox",
              { t:4,
                f:[ " invalid" ],
                x:{ r:[ "InvoiceRoomRateTotal",
                    "RoomRateTotal" ],
                  s:"_0!=_1" } } ] } },
        " ",
        { t:7,
          e:"button",
          a:{ type:"button",
            "class":"btn btn-circle",
            title:"Change To Match Our Value" },
          v:{ click:"matchInvoiceRoomRateTotal" },
          f:[ "=" ] },
        " ",
        { t:7,
          e:"br" },
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"strong",
          f:[ "Invoice Fees Total" ] },
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"input",
          a:{ type:"text",
            name:"InvoiceFeesTotal",
            value:[ { t:2,
                r:"InvoiceFeesTotal" } ],
            "class":[ "NumberBox",
              { t:4,
                f:[ " invalid" ],
                x:{ r:[ "InvoiceFeesTotal",
                    "HotelFeesTotal" ],
                  s:"_0!=_1" } } ] } },
        " ",
        { t:7,
          e:"button",
          a:{ type:"button",
            "class":"btn btn-circle",
            title:"Change To Match Our Value" },
          v:{ click:"matchInvoiceFeesTotal" },
          f:[ "=" ] },
        " ",
        { t:7,
          e:"br" },
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"strong",
          f:[ "Invoice Tax Total" ] },
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"input",
          a:{ type:"text",
            name:"InvoiceTaxTotal",
            value:[ { t:2,
                r:"InvoiceTaxTotal" } ],
            "class":[ "NumberBox",
              { t:4,
                f:[ " invalid" ],
                x:{ r:[ "InvoiceTaxTotal",
                    "HotelTaxFeesTotal" ],
                  s:"_0!=_1" } } ] } },
        " ",
        { t:7,
          e:"button",
          a:{ type:"button",
            "class":"btn btn-circle",
            title:"Change To Match Our Value" },
          v:{ click:"matchInvoiceTaxTotal" },
          f:[ "=" ] },
        " ",
        { t:7,
          e:"br" },
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"strong",
          f:[ "Invoice Status" ] },
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"select",
          a:{ id:"ddlInvoiceStatus_Edit",
            name:"StatusId",
            value:[ { t:2,
                r:"StatusId" } ] },
          f:[ { t:7,
              e:"option",
              a:{ value:"0" },
              f:[ "n/a" ] },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"option",
                  a:{ value:[ { t:2,
                        r:"id" } ] },
                  f:[ { t:2,
                      r:"Name" } ] } ],
              n:52,
              r:"invoiceStatuses" } ] },
        " ",
        { t:7,
          e:"br" },
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"strong",
          f:[ "Comments" ] },
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"textarea",
          a:{ "data-html":"yep",
            rows:"5",
            cols:"10",
            name:"Comments",
            value:[ { t:2,
                r:"Comments" } ] } },
        " ",
        { t:7,
          e:"br" },
        { t:7,
          e:"br" },
        " ",
        { t:4,
          f:[ { t:7,
              e:"a",
              a:{ href:"#" },
              v:{ click:"showDetailsData" },
              f:[ { t:7,
                  e:"strong",
                  f:[ "Show Details" ] } ] } ],
          n:50,
          x:{ r:[ "showDetails" ],
            s:"!_0" } },
        { t:4,
          n:51,
          f:[ { t:7,
              e:"div",
              a:{ "class":"wideGrid" },
              f:[ { t:7,
                  e:"strong",
                  f:[ "Taxes" ] },
                " ",
                { t:7,
                  e:"table",
                  a:{ id:"tbl_Taxes",
                    "class":"table table-bordered table-condensed" } } ] } ],
          x:{ r:[ "showDetails" ],
            s:"!_0" } },
        " ",
        { t:7,
          e:"br" },
        { t:7,
          e:"br" } ] },
    " ",
    { t:7,
      e:"div",
      a:{ "class":"right" },
      f:[ "Corrections ",
        { t:7,
          e:"a",
          a:{ tabindex:"-1",
            href:"#correctionsExplanation",
            "class":"infoLink" },
          f:[ { t:7,
              e:"img",
              a:{ src:"https://adestinn2blob.blob.core.windows.net/images/ico-question.png",
                alt:"what's this" } } ] },
        " ",
        { t:7,
          e:"div",
          a:{ id:"correctionsExplanation",
            "class":"infoBox" },
          f:[ "How To Correct: ",
            { t:7,
              e:"ol",
              f:[ { t:7,
                  e:"li",
                  f:[ "If any fields are red, this means either we charged the member incorrectly, or the hotel charged ",
                    { t:7,
                      e:"em",
                      f:[ "us" ] },
                    " incorrectly" ] },
                " ",
                { t:7,
                  e:"li",
                  f:[ { t:7,
                      e:"p",
                      f:[ "If the hotel is correct, update our values in the table accordingly." ] },
                    " ",
                    { t:7,
                      e:"p",
                      f:[ "Choose ",
                        { t:7,
                          e:"em",
                          f:[ "Refund" ] },
                        " if we have charged the member at least 10 cents more than the hotel invoiced us; this will cause the actual vacation data to be updated and the member's VSA to be refunded. If we didn't charge enough, we eat it." ] },
                    " ",
                    { t:7,
                      e:"p",
                      f:[ "If we are correct, update the invoice values accordingly (pay the hotel the correct amount instead of what they invoiced us)." ] },
                    " ",
                    { t:7,
                      e:"p",
                      f:[ "Often when the hotel is incorrect, it is because they are using the current tax rates instead of the ones at the time of booking." ] } ] },
                " ",
                { t:7,
                  e:"li",
                  f:[ "The corrections are applied upon saving" ] } ] } ] },
        " ",
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"input",
          a:{ id:"chkRefund",
            type:"checkbox",
            checked:[ { t:2,
                r:"Refund" } ] } },
        " ",
        { t:7,
          e:"label",
          a:{ "for":"chkRefund" },
          f:[ "Refund" ] },
        " ",
        { t:7,
          e:"br" },
        " ",
        { t:4,
          f:[ { t:7,
              e:"input",
              a:{ type:"checkbox",
                id:"chkToggleOld",
                checked:[ { t:2,
                    r:"DisplayOld" } ] } },
            " ",
            { t:7,
              e:"label",
              a:{ "for":"chkToggleOld" },
              f:[ "Show Original Values" ] },
            " ",
            { t:7,
              e:"a",
              a:{ href:"#originalValuesExplanation",
                "class":"infoLink" },
              f:[ { t:7,
                  e:"img",
                  a:{ src:"https://adestinn2blob.blob.core.windows.net/images/ico-question.png",
                    alt:"what's this" } } ] },
            " ",
            { t:7,
              e:"div",
              a:{ id:"originalValuesExplanation",
                "class":"infoBox" },
              f:[ "This is a quick way to revert corrections or simply view what was corrected" ] },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"a",
                  a:{ href:"#" },
                  v:{ click:"revertCorrections" },
                  f:[ "Revert To Original Values" ] } ],
              n:50,
              r:"DisplayOld" } ],
          n:50,
          r:"hasCorrections" },
        " ",
        { t:7,
          e:"table",
          a:{ "class":"table table-bordered table-condensed editgrid" },
          m:[ { t:4,
              f:[ "style=\"border: 2px solid green;\"" ],
              r:"Refund" } ],
          f:[ { t:7,
              e:"tr",
              f:[ { t:7,
                  e:"th",
                  f:[ "Stay Date" ] },
                " ",
                { t:7,
                  e:"th",
                  f:[ "Room Rate" ] },
                " ",
                { t:7,
                  e:"th",
                  f:[ "Fee" ] },
                " ",
                { t:7,
                  e:"th",
                  f:[ "Tax" ] } ] },
            " ",
            { t:7,
              e:"tr",
              a:{ "class":"totals" },
              f:[ { t:7,
                  e:"td",
                  f:[ "Totals ",
                    { t:7,
                      e:"span",
                      a:{ "class":"sideNote" },
                      f:[ "(",
                        { t:2,
                          r:"Nights.length" },
                        " Nights)" ] } ] },
                " ",
                { t:7,
                  e:"td",
                  f:[ { t:7,
                      e:"input",
                      a:{ type:"text",
                        min:"0",
                        value:[ { t:2,
                            r:"RoomRateTotal" } ],
                        "class":[ "NumberBox",
                          { t:4,
                            f:[ " invalid" ],
                            x:{ r:[ "InvoiceRoomRateTotal",
                                "RoomRateTotal" ],
                              s:"_0!=_1" } } ] } },
                    " ",
                    { t:7,
                      e:"button",
                      a:{ type:"button",
                        "class":"btn btn-circle",
                        title:"Change To Match Invoice" },
                      v:{ click:"matchRoomRateTotal" },
                      f:[ "=" ] } ] },
                " ",
                { t:7,
                  e:"td",
                  f:[ { t:7,
                      e:"input",
                      a:{ type:"text",
                        min:"0",
                        value:[ { t:2,
                            r:"HotelFeesTotal" } ],
                        "class":[ "NumberBox",
                          { t:4,
                            f:[ " invalid" ],
                            x:{ r:[ "InvoiceFeesTotal",
                                "HotelFeesTotal" ],
                              s:"_0!=_1" } } ] } },
                    " ",
                    { t:7,
                      e:"button",
                      a:{ type:"button",
                        "class":"btn btn-circle",
                        title:"Change To Match Invoice" },
                      v:{ click:"matchHotelFeesTotal" },
                      f:[ "=" ] } ] },
                " ",
                { t:7,
                  e:"td",
                  f:[ { t:7,
                      e:"input",
                      a:{ type:"text",
                        min:"0",
                        value:[ { t:2,
                            r:"HotelTaxFeesTotal" } ],
                        "class":[ "NumberBox",
                          { t:4,
                            f:[ " invalid" ],
                            x:{ r:[ "InvoiceTaxTotal",
                                "HotelTaxFeesTotal" ],
                              s:"_0!=_1" } } ] } },
                    " ",
                    { t:7,
                      e:"button",
                      a:{ type:"button",
                        "class":"btn btn-circle",
                        title:"Change To Match Invoice" },
                      v:{ click:"matchHotelTaxFeesTotal" },
                      f:[ "=" ] } ] } ] },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"tr",
                  f:[ { t:7,
                      e:"td",
                      f:[ { t:2,
                          r:"StayDate" } ] },
                    " ",
                    { t:7,
                      e:"td",
                      f:[ { t:7,
                          e:"input",
                          a:{ "class":"NumberBox",
                            type:"text",
                            min:"0",
                            value:[ { t:4,
                                f:[ { t:2,
                                    r:"DestinationRoomRate" } ],
                                n:50,
                                r:"DisplayOld" },
                              { t:4,
                                n:51,
                                f:[ { t:2,
                                    r:"RoomRate" } ],
                                r:"DisplayOld" } ] } } ] },
                    " ",
                    { t:7,
                      e:"td",
                      f:[ { t:7,
                          e:"input",
                          a:{ "class":"NumberBox",
                            type:"text",
                            min:"0",
                            value:[ { t:4,
                                f:[ { t:2,
                                    r:"DestinationHotelFees" } ],
                                n:50,
                                r:"DisplayOld" },
                              { t:4,
                                n:51,
                                f:[ { t:2,
                                    r:"HotelFees" } ],
                                r:"DisplayOld" } ] } } ] },
                    " ",
                    { t:7,
                      e:"td",
                      f:[ { t:7,
                          e:"input",
                          a:{ "class":"NumberBox",
                            type:"text",
                            min:"0",
                            value:[ { t:4,
                                f:[ { t:2,
                                    r:"DestinationHotelTaxFees" } ],
                                n:50,
                                r:"DisplayOld" },
                              { t:4,
                                n:51,
                                f:[ { t:2,
                                    r:"HotelTaxFees" } ],
                                r:"DisplayOld" } ] } } ] } ] } ],
              n:52,
              r:"Nights" },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"tr",
                  a:{ "class":"totals" },
                  f:[ { t:7,
                      e:"td",
                      f:[ "Diff ",
                        { t:7,
                          e:"span",
                          a:{ "class":"sideNote" },
                          f:[ "(Total: ",
                            { t:2,
                              x:{ r:[ "helpers" ],
                                s:"_0.getTotalDiff()" } },
                            ")" ] } ] },
                    " ",
                    { t:7,
                      e:"td",
                      f:[ { t:2,
                          x:{ r:[ "utils",
                              "RoomRateTotal",
                              "InvoiceRoomRateTotal" ],
                            s:"_0.roundNumber(_1-_2,2)" } } ] },
                    " ",
                    { t:7,
                      e:"td",
                      f:[ { t:2,
                          x:{ r:[ "utils",
                              "HotelFeesTotal",
                              "InvoiceFeesTotal" ],
                            s:"_0.roundNumber(_1-_2,2)" } } ] },
                    " ",
                    { t:7,
                      e:"td",
                      f:[ { t:2,
                          x:{ r:[ "utils",
                              "HotelTaxFeesTotal",
                              "InvoiceTaxTotal" ],
                            s:"_0.roundNumber(_1-_2,2)" } } ] } ] } ],
              n:50,
              x:{ r:[ "helpers" ],
                s:"_0.getTotalDiff()!==0" } } ] },
        " ",
        { t:4,
          f:[ { t:7,
              e:"textarea",
              a:{ placeholder:"Manual Change Notes",
                value:[ { t:2,
                    r:"ManualChangeNotes" } ] } } ],
          n:50,
          r:"Refund" },
        { t:4,
          n:51,
          f:[ { t:7,
              e:"textarea",
              a:{ placeholder:"Correction Comment",
                value:[ { t:2,
                    r:"CorrectionComment" } ] } } ],
          r:"Refund" } ] },
    " ",
    { t:7,
      e:"br",
      a:{ "class":"clear" } } ] };});
